// Generated by CoffeeScript 2.7.0
var Admin__TemplatePostsController;

import MessageCards from '../concerns/message_cards.js';

import MessageNavActions from './concerns/message_nav_actions.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

export default Admin__TemplatePostsController = (function() {
  class Admin__TemplatePostsController extends Skylark.App.BaseController {
    show() {
      this.messageType = 'template_post';
      return this._prepareCards();
    }

  };

  Admin__TemplatePostsController.include(MessageCards, MessageNavActions, ToggleNavMenuAction);

  return Admin__TemplatePostsController;

}).call(this);
